import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { authClient } from '@/lib/auth'
import { useTopNav } from '@/context/top-nav-provider'
import { Main } from '@/components/layout/main'
import { TasksWithoutNotesReport } from '@/features/reports/tasks-without-notes'

function TasksWithoutNotesReportPage() {
  const { data: activeOrganization, isPending } = authClient.useActiveOrganization()
  const { setLinks, setFixed } = useTopNav()

  useEffect(() => {
    setLinks([
      { title: 'Overview', href: '/' },
      { title: 'Reports', href: '/reports' },
      { title: 'Tasks without Notes', href: '/reports/tasks-without-notes', isActive: true },
    ])
    setFixed(true)
    return () => { setLinks([]) }
  }, [setLinks, setFixed])

  if (isPending || !activeOrganization) return null

  return (
    <Main className='flex flex-1 flex-col gap-6'>
      <TasksWithoutNotesReport organizationId={activeOrganization.id} />
    </Main>
  )
}

export const Route = createFileRoute('/_authenticated/_organization/reports/tasks-without-notes')({
  beforeLoad: async () => requireRoles(['support_coordinator', 'admin']),
  component: TasksWithoutNotesReportPage,
})
